/* Mega Menu — Geoffrey's Diamonds
 * Complements Broadcast's <hover-disclosure> element: keyboard + a11y polish.
 * Open/close animation & click-outside are already handled by the theme. */

(function () {
  const items = document.querySelectorAll('.menu__item.parent, .menu__item.grandparent');
  if (!items.length) return;

  items.forEach((item) => {
    const panel = item.querySelector('.header__dropdown--mega');
    const link = item.querySelector('.navlink--toplevel');
    if (!panel || !link) return;

    link.setAttribute('aria-haspopup', 'true');

    const setExpanded = (open) => {
      link.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    setExpanded(false);

    item.addEventListener('mouseenter', () => setExpanded(true));
    item.addEventListener('mouseleave', () => setExpanded(false));
    item.addEventListener('focusin', () => setExpanded(true));
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) setExpanded(false);
    });

    item.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        setExpanded(false);
        panel.classList.remove('is-visible');
        if (link instanceof HTMLElement) link.blur();
      }
    });
  });
})();
